module.exports = __webpack_public_path__ + "img/20190904140921.c9df2ee7.jpg";